import type { Translation } from '../i18n-types';

const de = {
    // General
    appTitle: 'Intranet',
    welcome: 'Willkommen im {title}!',
    loading: 'Lädt ...',
    error: 'Ein Fehler ist aufgetreten',

    language: 'Language',
    languages: {
        en: 'English',
        de: 'Deutsch',
    },

    // Darstellung
    appearance: 'Darstellung',
    themeLight: 'Hell',
    themeDark: 'Dunkel',
    themeSystem: 'System',
    switchAppearance: 'Darstellung: {mode}. Zum Wechseln klicken.',

    // Navigation
    home: 'Startseite',
    admin: 'Verwaltung',
    logout: 'Abmelden',

    // User Info
    userInfo: 'Benutzerinformationen',
    email: 'E-Mail',
    displayName: 'Anzeigename',
    firstName: 'Vorname',
    lastName: 'Nachname',
    groups: 'Gruppen',

    // App Cards
    applications: 'Anwendungen',
    noAppsAvailable: 'Keine Anwendungen für Ihre Gruppen verfügbar.',
    openApp: '{application} öffnen',
    public: 'Öffentlich',
    visibility: 'Sichtbarkeit',

    // Suche & Favoriten
    searchApps: 'Anwendungen suchen',
    clearSearch: 'Suche zurücksetzen',
    noSearchResults: 'Keine Anwendungen passen zu „{query}“.',
    favorites: 'Favoriten',
    otherApplications: 'Alle Anwendungen',
    addFavorite: 'Zu Favoriten hinzufügen',
    removeFavorite: 'Aus Favoriten entfernen',

    // Admin Section
    adminPanel: 'Verwaltungsbereich',
    manageApps: 'Anwendungen verwalten',
    addApp: 'Anwendung hinzufügen',
    editApp: 'Anwendung bearbeiten',
    deleteApp: 'Anwendung löschen',
    appTitle_field: 'Titel',
    appDescription: 'Beschreibung',
    appImage: 'Bild-URL',
    appLink: 'Link',
    appGroups: 'Zugriffsgruppen',
    appActive: 'Aktiv',
    appSortOrder: 'Sortierung',
    save: 'Speichern',
    cancel: 'Abbrechen',
    delete: 'Löschen',
    confirmDelete: 'Möchten Sie diese Anwendung wirklich löschen?',

    // Messages
    saveSuccess: 'Erfolgreich gespeichert',
    deleteSuccess: 'Erfolgreich gelöscht',
    saveFailed: 'Speichern fehlgeschlagen',
    deleteFailed: 'Löschen fehlgeschlagen',
    accessDenied: 'Zugriff verweigert. Administrator-Rechte erforderlich.',

    // Login
    loginRequired: 'Bitte melden Sie sich an, um fortzufahren',
    loginWithOIDC: 'Mit OIDC anmelden',
    loggingIn: 'Anmeldung läuft...',
    loginFailed: 'Die Anmeldung ist fehlgeschlagen. Bitte erneut versuchen.',
    redirectingIn: 'Weiterleitung in {countdown} Sekunde{{n}} ...',

    // Session / OIDC
    refreshSession: 'Sitzung aktualisieren',
    refreshingSession: 'Sitzung wird aktualisiert…',
    refreshGroupAssignments: 'Gruppenzuordnungen aktualisieren',
    reloginToRefreshClaims: 'Neu anmelden, um Berechtigungen zu aktualisieren',
    reloggingIn: 'Weiterleitung zur Anmeldung…',

    // AdminPage specific translations
    everyone: 'Alle',
    internal: 'Intern',
    active: 'Aktiv',
    inactive: 'Inaktiv',
    actions: 'Aktionen',
    tableHeaders: {
        title: 'Titel',
        link: 'Link',
        groups: 'Gruppen',
        visibility: 'Sichtbarkeit',
        active: 'Aktiv',
        actions: 'Aktionen',
    },
    noAppsCreated: 'Noch keine Anwendungen erstellt.',
    dropImage: 'Bild hierher ziehen oder klicken, um hochzuladen',
    supportsImage: 'Unterstützt JPG, PNG (max 5MB)',
    orEnterImageUrl: 'Oder geben Sie eine Bild-URL ein:',
    enterGroupName: 'Gruppennamen eingeben',
    add: 'Hinzufügen',
    leaveEmptyForEveryone: 'Leer lassen für alle',
    preview: 'Vorschau',
    imageUrlPlaceholder: 'https://example.com/image.jpg',
    linkPlaceholder: 'https://example.com',
} satisfies Translation;

export default de;
